/**
 * Helpers de data no fuso LOCAL do navegador do usuário.
 *
 * O uso comum de `new Date().toISOString().split("T")[0]` para pegar "hoje"
 * está incorreto porque `toISOString()` converte para UTC. À noite em São
 * Paulo (UTC-3), por exemplo, 23:35 do dia 07 vira `2026-08-08T02:35Z` — a
 * data volta com um dia à frente.
 *
 * O usuário do sistema é o porteiro, cujo navegador está fisicamente no fuso
 * do condomínio. Basta usar os getters locais (`getFullYear`, `getMonth`,
 * `getDate`) para obter a data correta do ponto de vista dele.
 */

export function todayLocal(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function timeLocal(d = new Date()) {
  const h = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${h}:${min}`;
}

/** Retorna { date: 'YYYY-MM-DD', time: 'HH:MM' } no fuso local. */
export function nowLocalParts(d = new Date()) {
  return { date: todayLocal(d), time: timeLocal(d) };
}
